import React from "react";
import "./Technology.css";
import MovingCarLottie from "../../common_components/animation/moving_car_lottie/Moving_Car_Lottie";
import Common_Title from "../../common_components/common_title/Common_Title";

const Technology = () => {
  return (
    <section className="technology">
      <div className="container">
        <Common_Title
          pageTitle="Technology"
          boxText="Driven By Technology & Innovation"
        />

        <div className="tech_wrapper">
          {/* LEFT FEATURES */}
          <div className="features_left">
            <div className="feature_box">
              AI-Powered Auto Inspection & Damage Detection
            </div>
            <div className="feature_box">Real-Time Tracking</div>
            <div className="feature_box">Doorstep Cashless Payments</div>
          </div>

          {/* RIGHT FEATURES */}
          <div className="features_right">
            <div className="feature_box">
              Comprehensive Dashboard & Smart Queue Manager
            </div>
            <div className="feature_box">White-Label Customer App</div>
            <div className="feature_box">Covid-Safe Protocols</div>
          </div>
        </div>

        {/* CAR  */}
        <div className="banner_animation">
          <MovingCarLottie />
        </div>
      </div>
    </section>
  );
};

export default Technology;
